<script setup>
import { defineProps} from "vue";

//==================================================================//
//========================= Props & Emits ==========================//
//==================================================================//

const props = defineProps([
    "dado",
]);

</script>

<template>

    <v-card class="c-cartao">

        <v-card-title class="c-cartao__titulo">

            <h3 class="c-titulo">

                Observações

            </h3>

        </v-card-title>

        <div class="c-cartao__conteudo">

            <div class="c-campo">

                <v-textarea
                    :value="props?.dado?.observacao"
                    label="Observações"
                    variant="outlined"
                    no-resize
                    outlined
                    auto-grow
                    disabled
                ></v-textarea>

            </div>

        </div>

    </v-card>

</template>

<style scoped>

.c-cartao__titulo{
    display: grid; 
    grid-template-columns: 1fr; 
    grid-template-rows: 1fr; 
    gap: 10px; 
    grid-template-areas: 
        "titulo";
}

.c-titulo {
    grid-area: titulo;
}

</style>